import { LANGUAGES, LESSONS, SUBJECTS, VEHICLES } from '@typing-racer/shared';
import { clear, h } from '../dom.js';
import { affiliatePanel } from './affiliate.js';

export const APP_VERSION = __APP_VERSION__;

export function renderAbout(root: HTMLElement, onBack: () => void): void {
  clear(root);
  root.append(
    h(
      'div',
      { class: 'center' },
      h(
        'div',
        { class: 'panel wide stack' },
        h('div', { class: 'row', style: 'justify-content:space-between' }, h('h1', {}, 'ℹ️ About Typing ', h('span', { class: 'accent' }, 'Racer')), h('button', { class: 'btn small ghost', onclick: onBack }, '← Back')),
        h('p', {}, 'Typing Racer is a 3D typing game. Everyone types the same sentences and the faster and more accurately you type, the faster your car drives. Up to six players race together; empty seats are filled by bots at a difficulty you choose.'),
        h(
          'ul',
          { class: 'about-list' },
          h('li', {}, h('b', {}, 'Races: '), 'motivational sentences or fact packs, F1-style league points, a bonus for the best accuracy, and personalised typing hints after every race.'),
          h('li', {}, h('b', {}, 'Typing lessons: '), `${LESSONS.length} touch-typing lessons with an on-screen finger guide.`),
          h('li', {}, h('b', {}, 'Learn a language: '), `${LANGUAGES.map((l) => l.name).join(', ')}. Type the phrase, see its meaning.`),
          h('li', {}, h('b', {}, 'Learn a subject: '), `${SUBJECTS.map((s) => s.name).join(', ')}. Every line is a real fact.`),
          h('li', {}, h('b', {}, 'Accounts: '), 'register your name with a password to protect it and get progress graphs and coaching over time.'),
          h('li', {}, h('b', {}, 'Vehicles and views: '), `${VEHICLES.length} vehicles in a blocky style (or low-poly models), three camera views, generated music and key sounds.`),
        ),
        h('p', { class: 'muted small' }, 'Typos must be fixed with Backspace. A 30-key clean streak gives a nitro boost. Tab changes the camera, Esc quits.'),
        affiliatePanel(),
        h('div', { class: 'row', style: 'justify-content:space-between' }, h('span', { class: 'muted small' }, `Version ${APP_VERSION}`), h('span', { class: 'muted small' }, 'Built with Three.js, TypeScript and Vite. No audio or model files: everything is generated in your browser.')),
      ),
    ),
  );
}
